import type { CastCollection } from "@/types/aggregate-items";
import { imageUrl } from "@/utils/image";
export interface Input {
  item: CastCollection;
}
$ const { item } = input;
$ const mosaicClasses: { [key: number]: string } = {
  1: "cast-discover-collection-card__image-mosaic--1",
  2: "cast-discover-collection-card__image-mosaic--2",
  3: "cast-discover-collection-card__image-mosaic--3",
};

<a href=item.collectionUrl class="cast-discover-collection-card">
  $ const mosaicClass = mosaicClasses[item.images.length];
  <div class="cast-discover-collection-card__image-mosaic-container">
    <div class=["cast-discover-collection-card__image-mosaic", mosaicClass]>
      <for|image| of=item.images>
        <div class="cast-discover-collection-card__image-mosaic__image">
          <img src=imageUrl(image) alt=image.altText>
        </div>
      </for>
    </div>
  </div>
  <div class="cast-discover-collection-card__details">
    <div class="cast-discover-collection-card__title">
      ${item.title}
    </div>
    <div class="cast-discover-collection-card__subtitle">
      by ${item.influencer.name}
    </div>
  </div>
</a>
